import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formatage CHF déterministe (évite les mismatches SSR/hydratation liés aux
 * données ICU locales du runtime Worker vs du navigateur).
 */
export function fmtChf(n: number): string {
  const rounded = Math.round(n);
  const s = Math.abs(rounded).toString();
  const groups: string[] = [];
  let i = s.length;
  while (i > 3) {
    groups.unshift(s.slice(i - 3, i));
    i -= 3;
  }
  groups.unshift(s.slice(0, i));
  const sign = rounded < 0 ? "-" : "";
  return `${sign}${groups.join("'")}.–`;
}

/** Formatage CHF avec préfixe CHF (ex: "CHF 1'400.–"). */
export function fmtChfFull(n: number): string {
  return `CHF ${fmtChf(n)}`;
}

/** Date courte déterministe, sans dépendre de la locale du runtime. */
export function fmtDateShort(iso: string): string {
  const d = new Date(iso);
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();
  return `${day}.${month}.${year}`;
}

/** Date/heure déterministe, sans dépendre de la locale du runtime. */
export function fmtDateTimeShort(iso: string): string {
  const d = new Date(iso);
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();
  const hour = String(d.getUTCHours()).padStart(2, "0");
  const minute = String(d.getUTCMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} · ${hour}:${minute}`;
}

/** Formatage bytes déterministe. */
export function fmtBytes(bytes: number): string {
  if (bytes === 0) return "0 o";
  const k = 1024;
  const sizes = ["o", "Ko", "Mo", "Go"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round(bytes / Math.pow(k, i) * 10) / 10} ${sizes[i]}`;
}
